import * as fs from "fs";
import * as ko from "knockout";
import { RNSAPI, Routing } from "../../api";
import '../dialog/dialog';
import { DialogViewModel } from '../dialog/dialog';

class CalculatorViewModel {
    RVGList = new Array();

    //var self = this;
    //self.filterByLanguage = function (lang) {
    //    self.selectedLanguage(lang);
    //};
    
    modalTitle = ko.observable("");
    modalKeys = ko.observableArray([]);
    modalColumns = ko.observableArray([]);
    modalData = ko.observableArray([]);
    modalHandleSelection: KnockoutObservable<(selectedObject: any) => void> = ko.observable();

    rechNr = ko.observable("-/-");
    statusModalTitle = ko.observable("");
    statusModalText = ko.observable("");
    generateInvoice = ko.observable(false);
    statusModalFooter = ko.observable(true);
    selectedMandant = ko.observable();
    

    async pickGeneric (title, keys, columns, data) {
        this.modalTitle(title);
        this.modalKeys(keys);
        this.modalColumns(columns);
        this.modalData(data);
    };

    async pickCase() {
        let cases = (await RNSAPI.getCases()).Payload.Cases;
        this.pickGeneric("Akte", ["Registernummer", "Rubrum", "Wegen"], ["Registernummer", "Rubrum", "Wegen"], cases);
        this.modalHandleSelection((selectedObject) => {
            $("#pnr").val(selectedObject()["Registernummer"]);
            this.ClearRVGList();
            //this.loadRVGEntries();
        });
        $('#modal').modal('show');
    };

    //async pickMandant() {
    //    let caseID = $("#pnr").val();
    //    let persons = (await RNSAPI.getPersonsForCaseId(caseID.toString())).Payload.Addresses[0];
    //    this.pickGeneric("Mandanten", ["Rechtsform", "FirstName", "Name1"], ["Anrede / Rechtsform", "Vorname", "Nachname"], persons);
    //    this.modalHandleSelection((selectedObject) => {
    //        this.selectedMandant(selectedObject()["Keyword"]);
    //    });
    //    $('#modal').modal('show');
    //    //let mandanten = persons[0].map(p => new Person("mandant", p.Keyword));
    //}

    async abgleich() {
        alert("Abgleich");

        //let response = await RNSAPI.rvgAbgleich();
        //if (response.Type !== "AbgleichSuccessful") {
        //    alert("Fehler beim Abgleich.");
        //}

    }

    async postData() {
   
        var keys = Object.keys(this.RVGList);
        var len = keys.length

        var filtered = this.RVGList.filter(function (el) {
            return el != null;
        });
        var caseID = $("#pnr").val();

        if (len !== 0 && caseID !== "") {

            this.generateInvoice(true);

            //this.pickMandant();
          

            let response = await RNSAPI.rvgAddEntry(caseID, filtered);
            if (response.Type !== "NewEntryResultSuccessful") {
                this.statusModalTitle('<i class="far fa-times-circle  mr-2"></i> Fehler');
                this.statusModalText('Die Rechnung konnte nicht erstellt werden.<br />Bitte versuchen Sie es erneut.<br /><br />Sollte es noch immer so einem Fehler kommen so wenden Sie sich an unseren Support unter <a href="mailto:info@rainmaker.de">info@rainmaker.de</a>');
                $("#statusModal").modal('show');
            } else {
                this.rechNr(response.Payload.rechNr);
                this.statusModalTitle('<i class="far fa-check-circle mr-2"></i> Erfolgreich');
                this.statusModalText('Die Rechnung mit der Rechnungsnummer <span class="text-default">' + this.rechNr() + '</span> wurde erstellt.');
                $("#statusModal").modal('show');
                RNSAPI.createHistoryEntry(caseID, "Rechnung erstellt / Rechnungsnummer: " + this.rechNr());
            }

        } else {
            this.statusModalTitle('<i class="far fa-times-circle  mr-2"></i> Fehler');
            this.statusModalText('Die Rechnung kann nicht ohne Gebühren oder einer Registernummer gespeichert werden.');
            $("#statusModal").modal('show');
        }


    }

    DeleteRVGEntry(id) {

        console.log(id);
        //if (id !== "0" || id !== "") {
        //    var row = document.getElementById("entry" + id);
        //    row.parentNode.removeChild(row);
        //    delete this.RVGList[id];
        //    this.CheckRVGTableValue();
        //}
        //else {
        //    console.log("triggered");
        //}
    }


    
    CheckRVGTableValue() {

        var keys = Object.keys(this.RVGList);
        var len = keys.length

        if (len.toString() == "0") {
            var tableRef = document.getElementById('rvgtable').getElementsByTagName('tbody')[0];
            var newRow = tableRef.insertRow(tableRef.rows.length);

            var cell = new Array();
            cell[0] = newRow.insertCell(0);
            cell[0].setAttribute("class", "text-center text-muted");
            cell[0].setAttribute("id", "noentry");

            var text = new Array();
            text[0] = document.createTextNode("Keine Einträge vorhanden.");

            cell[0].appendChild(text[0]);
            cell[0].setAttribute("colspan", "8");
        }
    }

    RVGZuzug() {
        if ($("#pnr").val() !== "") {
            var pnr = $("#pnr").val();
            var form = (document.getElementById("rvgform") as any);
            form.reset();
            localStorage.clear();
            $("#rvgbezeichnung").val("Zuzüglich");
            $("#rvgnummer").attr('disabled', 'disabled');
            $("#rvgverfahren").attr('disabled', 'disabled');
            $("#rvggebuehrensatz").attr('disabled', 'disabled');
            $("#rvgstreitwert").attr('disabled', 'disabled');

            $("#streitwertContainer").hide();
            $("#rvgbezeichnung").val("Zuzüglich");

            $('#addrvggeb_modal').modal('show');
            $("#rvgbezeichnung").val("Zuzüglich");

        } else {
            this.statusModalTitle('<i class="far fa-times-circle  mr-2"></i> Fehler');
            this.statusModalText('Es muss eine Registernummer angegeben werden.');
            $("#statusModal").modal('show');
        }
    } 


    RVGAbzug() {
        if ($("#pnr").val() !== "") {
            var pnr = $("#pnr").val();
            var form = (document.getElementById("rvgform") as any);
            form.reset();
            localStorage.clear();

            $("#rvgnummer").attr('disabled', 'disabled');
            $("#rvgverfahren").attr('disabled', 'disabled');
            $("#rvggebuehrensatz").attr('disabled', 'disabled');
            $("#rvgstreitwert").attr('disabled', 'disabled');

            $("#streitwertContainer").hide();
            $("#rvgbezeichnung").val("Vorschuss");

            $('#addrvggeb_modal').modal('show');

        } else {
            this.statusModalTitle('<i class="far fa-times-circle  mr-2"></i> Fehler');
            this.statusModalText('Es muss eine Registernummer angegeben werden.');
            $("#statusModal").modal('show');
        }
    } 



    ClearRVGList() {
         
        var tableRef = document.getElementById('rvgtable').getElementsByTagName('tbody')[0];
        for (var i = 0; i < this.RVGList.length; i++) {
            tableRef.deleteRow(0);
        }
        this.RVGList.length = 1;
        var cell = new Array();
        var newRow = tableRef.insertRow(tableRef.rows.length);

        $("#noentry").remove();

        cell[0] = newRow.insertCell(0);
        cell[0].setAttribute("class", "text-center text-muted");
        cell[0].setAttribute("id", "noentry");

        var text = new Array();
        text[0] = document.createTextNode("Keine Einträge vorhanden.");

        cell[0].appendChild(text[0]);
        cell[0].setAttribute("colspan", "7");
        //this.RVGList.length = 1;
        //var newRow = tableRef.deleteRow(tableRef.rows.length);
    }

    

    SummeRVGUSt() {
        $('#rvgQuestionModal').modal('hide');
        this.SummeRVGGeb();

        var keys = Object.keys(this.RVGList);
        var len = keys.length

        var berechnung: any = 0;
        var ustberechnung: any = 0;
        for (var i = 1; i < len + 1; i++) {
            if (this.RVGList[i].Art === '=') continue;
            var gebuehr = parseFloat(this.RVGList[i].Gebuehr.replace(',', '.'));
            berechnung += gebuehr;
        }

        berechnung = Math.round(berechnung * 100) / 100;
        berechnung = berechnung.toFixed(2);

        ustberechnung = (berechnung / 100) * 19;

        berechnung = berechnung.toString();
        berechnung = berechnung.replace('.', ',');
        ustberechnung = ustberechnung.toFixed(2);
        ustberechnung = ustberechnung.toString();
        ustberechnung = ustberechnung.replace('.', ',');



        if (berechnung !== "0,00") {
            this.RVGList[len + 1] = { Speichern: true, Art: 'U19', Nummer: "7008", Bezeichnung: "19,00 % Umsatzsteuer aus " + berechnung + " EUR", GebuehrenSatz: "", Streitwert: "", Gebuehr: ustberechnung }

            var tableRef = document.getElementById('rvgtable').getElementsByTagName('tbody')[0];
            var newRow = tableRef.insertRow(tableRef.rows.length);


            var counter = len + 1;
            newRow.setAttribute("id", "entry" + counter);

            var cell = new Array();
            for (var i = 0; i < 8; i++) {
                cell[i] = newRow.insertCell(i);
                cell[i].setAttribute("class", "text-left");
            }

            cell[7].innerHTML = '<i class="fas fa-trash" data-bind="click: $root.testt" aria-hidden="true"></i>';

            var text = new Array();
            text[0] = document.createTextNode(this.RVGList[len + 1].Art);
            text[1] = document.createTextNode(this.RVGList[len + 1].Nummer);
            text[2] = document.createTextNode(this.RVGList[len + 1].Bezeichnung);
            text[3] = document.createTextNode(this.RVGList[len + 1].GebuehrenSatz);
            text[4] = document.createTextNode(this.RVGList[len + 1].Streitwert);
            text[5] = document.createTextNode(this.RVGList[len + 1].Gebuehr);
            text[6] = document.createTextNode("");


            for (var i = 0; i < 7; i++) {
                cell[i].appendChild(text[i]);
            }
        }
    }


    SummeRVGGeb() {
        $('#rvgQuestionModal').modal('hide');
        var keys = Object.keys(this.RVGList);
        var len = keys.length

        var berechnung: any = 0;
        for (var i = 1; i < len + 1; i++) {
            if (this.RVGList[i].Art === '=') continue;
            var gebuehr = parseFloat(this.RVGList[i].Gebuehr.replace(',', '.'));
            berechnung += gebuehr;
        }

        berechnung = Math.round(berechnung * 100) / 100;
        berechnung = berechnung.toFixed(2);
        berechnung = berechnung.toString();
        berechnung = berechnung.replace('.', ',');

        if (berechnung !== "0,00") {
            if (this.RVGList[len].Art !== '=') {
                this.RVGList[len + 1] = { Speichern: true, Art: '=', Nummer: "", Bezeichnung: "Summe", GebuehrenSatz: "", Streitwert: "", Gebuehr: berechnung }

                var tableRef = document.getElementById('rvgtable').getElementsByTagName('tbody')[0];
                var newRow = tableRef.insertRow(tableRef.rows.length);


                var counter = len + 1;
                newRow.setAttribute("id", "entry" + counter);

                var cell = new Array();
                for (var i = 0; i < 8; i++) {
                    cell[i] = newRow.insertCell(i);
                    cell[i].setAttribute("class", "text-left");
                }

                cell[7].innerHTML = '<i class="fas fa-trash" onclick="DeleteRVGEntry(' + counter + ')" aria-hidden="true"></i>';

                var text = new Array();
                text[0] = document.createTextNode(this.RVGList[len + 1].Art);
                text[1] = document.createTextNode(this.RVGList[len + 1].Nummer);
                text[2] = document.createTextNode(this.RVGList[len + 1].Bezeichnung);
                text[3] = document.createTextNode(this.RVGList[len + 1].GebuehrenSatz);
                text[4] = document.createTextNode(this.RVGList[len + 1].Streitwert);
                text[5] = document.createTextNode(this.RVGList[len + 1].Gebuehr);
                text[6] = document.createTextNode("");


                for (var i = 0; i < 7; i++) {
                    cell[i].appendChild(text[i]);
                }
            }
        }

    }

    public colorTest(data, param1) {
        console.log("Hallo Welt");
    }

    public colorTests() {
        console.log("Hiho");
    }

    SummeRVGQuestion() {
        //var modal = document.getElementById("rvgQuestionModal");
        $('#rvgQuestionModal').modal('show');
    }

    OpenRVGGeb() {
        if ($("#pnr").val() !== "") {
            var pnr = $("#pnr").val();
            var form = (document.getElementById("rvgform") as any);
            form.reset();
            localStorage.clear();
            $('#addrvggeb_modal').modal('show');
        }
        else {
            this.statusModalTitle('<i class="far fa-times-circle  mr-2"></i> Fehler');
            this.statusModalText('Es muss eine Registernummer angegeben werden.');
            $("#statusModal").modal('show');
        }
    }

    
    async OpenRVGList() {
        let searchObject = {
            "Query": "",
            "Version": "2013"
        }
        let response = (await RNSAPI.rvgSearch(searchObject)).Payload.RVGGeb;
        this.pickGeneric("RVG Gebühren", ["ParagraphNummer", "ParagraphBezeichnung"], ["Gebühr", "Bezeichnung"], response);
        this.modalHandleSelection((selectedObject) => {
            $("#rvgnummer").val(selectedObject()["ParagraphNummer"]);
            $('#addrvggeb_modal').modal('show');
            this.UpdateRVGListDisplay();
        });
        $('#modal').modal('show');
    }

    async UpdateRVGListDisplay() {
        var pnr = $("#rvgnummer").val();
        pnr = pnr + " BY NUMBER";


        let searchObject = {
            "Query": pnr,
            "Version": "2013"
        }

        localStorage.setItem("rvgStreitwert", $("#rvgstreitwert").val() as string);


        let response = await RNSAPI.rvgSearch(searchObject);
        var rvgData = response.Payload.RVGGeb[0];

        if (typeof rvgData !== 'undefined') {
            localStorage.setItem("rvgNummer", rvgData.ParagraphNummer.trim());
            localStorage.setItem("rvgBezeichnung", rvgData.ParagraphBezeichnung.trim());
            localStorage.setItem("rvgVerfahren", rvgData.Verfahren.trim());
            localStorage.setItem("rvgGebuehrenSatz", rvgData.GebuehrenSatz.trim());
            localStorage.setItem("rvgStreitwert", ($("#rvgstreitwert").val() as string).trim());
            this.calculateGebuehr();

        }
        else {
            localStorage.clear();
            this.updateDisplay();
        }
        this.updateDisplay();
    }

    async calculateGebuehr() {
        var streitwert = localStorage.getItem("rvgStreitwert");
        var nummer = localStorage.getItem("rvgNummer"); //paragraph
        var version = "2013";

        let calculateObject = {
            "Streitwert": streitwert,
            "Paragraph": nummer,
            "Version": version
        }

        let response = await RNSAPI.rvgCalculate(calculateObject);

        var rvgData = response.Payload;

        localStorage.setItem("rvgBetrag", rvgData.Gebuehr.trim());

        this.updateDisplay();
    }

    updateDisplay() {
        $("#rvgverfahren").val(localStorage.getItem("rvgVerfahren"));
        if (localStorage.getItem("rvgStreitwert") === "" || localStorage.getItem("rvgStreitwert") === null) {
            $("#rvgbezeichnung").val(localStorage.getItem("rvgBezeichnung"));
        } else {
            $("#rvgbezeichnung").val(localStorage.getItem("rvgBezeichnung") + " aus " + localStorage.getItem("rvgStreitwert") + " EUR");
        }
        $("#rvggebuehrensatz").val(localStorage.getItem("rvgGebuehrenSatz"));
        $("#rvgbetrag").val(localStorage.getItem("rvgBetrag"));
    }

    notify = function (str) {
        console.log(str)
    }

    AddRVGEntry() {
        var rvgnummer = localStorage.getItem("rvgNummer");
        var rvgbezeichnung = $("#rvgbezeichnung").val();
        var rvgverfahren = localStorage.getItem("rvgVerfahren");
        var rvgstreitwert = localStorage.getItem("rvgStreitwert");
        var rvgbetrag = localStorage.getItem("rvgBetrag");
        var rvggebuehrensatz = localStorage.getItem("rvgGebuehrenSatz");


        if (rvgnummer !== null && rvgbezeichnung !== null && rvgbetrag !== null) {

            var keys = Object.keys(this.RVGList);
            var len = keys.length

            this.RVGList[len + 1] = { Speichern: true, Art: 'G', Nummer: rvgnummer, Bezeichnung: rvgbezeichnung, GebuehrenSatz: rvggebuehrensatz, Streitwert: rvgstreitwert, Gebuehr: rvgbetrag }

            var tableRef = document.getElementById('rvgtable').getElementsByTagName('tbody')[0];
            var newRow = tableRef.insertRow(tableRef.rows.length);


            var counter = len + 1;
            newRow.setAttribute("id", "entry" + counter);

            var cell = new Array();
            for (var i = 0; i < 8; i++) {
                cell[i] = newRow.insertCell(i);
                cell[i].setAttribute("class", "text-left");
            }

            //cell[7].innerHTML = '<button onclick="DeleteRVGEntry(' + counter + ')"><i class="fas fa-trash"></i></button>';
            //cell[7].innerHTML = "<button (click) =\"colorTests()\"><i class=\"fas fa-trash\"></i></button>";
            //cell[7].innerHTML = "<button data-bind='click: DeleteRVGEntry(2)'><i class='fas fa-trash'></i></button>"
            cell[7].innerHTML = '<i class="fas fa-trash" data-bind="click: $root.testt" aria-hidden="true" ></i>';

            //cell[7].innerHTML = "<button data-bind='click: notify.bind(this, 'Hello')'>T</button>";

            var text = new Array();
            text[0] = document.createTextNode(this.RVGList[len + 1].Art);
            text[1] = document.createTextNode(this.RVGList[len + 1].Nummer);
            text[2] = document.createTextNode(this.RVGList[len + 1].Bezeichnung);
            text[3] = document.createTextNode(this.RVGList[len + 1].GebuehrenSatz);
            text[4] = document.createTextNode(this.RVGList[len + 1].Streitwert);
            text[5] = document.createTextNode(this.RVGList[len + 1].Gebuehr);
            text[6] = document.createTextNode("19,00");


            for (var i = 0; i < 7; i++) {
                cell[i].appendChild(text[i]);
            }

            $("#noentry").remove();
      
            $('#addrvggeb_modal').modal('hide');

        }
        else {
            if ($("#rvgnummer").attr("disabled", "disabled") && $("#rvgverfahren").attr("disabled", "disabled")) {
                var keys = Object.keys(this.RVGList);
                var len = keys.length

                var rvgbe = $("#rvgbetrag").val();

                if ($("#rvgbezeichnung").val() === "Zuzüglich") {
                    this.RVGList[len + 1] = { Speichern: true, Art: '+', Nummer: "", Bezeichnung: rvgbezeichnung, GebuehrenSatz: "", Streitwert: "", Gebuehr: rvgbe }
                } else {
                    this.RVGList[len + 1] = { Speichern: true, Art: '-', Nummer: "", Bezeichnung: rvgbezeichnung, GebuehrenSatz: "", Streitwert: "", Gebuehr: "-"+rvgbe }

                }

                var tableRef = document.getElementById('rvgtable').getElementsByTagName('tbody')[0];
                var newRow = tableRef.insertRow(tableRef.rows.length);


                var counter = len + 1;
                newRow.setAttribute("id", "entry" + counter);

                var cell = new Array();
                for (var i = 0; i < 8; i++) {
                    cell[i] = newRow.insertCell(i);
                    cell[i].setAttribute("class", "text-left");
                }

                cell[7].innerHTML = '<i class="fas fa-trash" onclick="DeleteRVGEntry(' + counter + ')" aria-hidden="true"></i>';

                var text = new Array();
                text[0] = document.createTextNode(this.RVGList[len + 1].Art);
                text[1] = document.createTextNode(this.RVGList[len + 1].Nummer);
                text[2] = document.createTextNode(this.RVGList[len + 1].Bezeichnung);
                text[3] = document.createTextNode(this.RVGList[len + 1].GebuehrenSatz);
                text[4] = document.createTextNode(this.RVGList[len + 1].Streitwert);
                text[5] = document.createTextNode(this.RVGList[len + 1].Gebuehr);
                if (this.RVGList[len + 1].Art === "-") {
                    text[6] = document.createTextNode("19,00");
                } else {
                    text[6] = document.createTextNode("0,00");
                }
                //text[7] = document.createTextNode("<i class='fas fa-trash'></i>");
                
                


                for (var i = 0; i < 7; i++) {
                    cell[i].appendChild(text[i]);
                }

                $("#noentry").remove();

                $('#addrvggeb_modal').modal('hide');
            }
            else {
                this.statusModalTitle('<i class="far fa-times-circle  mr-2"></i> Fehler');
                this.statusModalText('Es wurden nicht alle erforderlichen Eingabefelder für die Berechnung ausgefüllt.');
                $("#statusModal").modal('show');
            }
        }

    }

    async loadRVGEntries() {
        var pnr = $("#pnr").val();
        if (pnr !== "") {
            let result = await RNSAPI.rvgLoadEntries(pnr.toString());
            if (result.Type === "LoadEntriesSuccessful") {
                let entries = result.Payload.Entries;
         

                for (var i = 0; i < entries.length; i++) {
                 
                    var keys = Object.keys(this.RVGList);
                    var len = keys.length

                    this.RVGList[len + 1] = { Art: entries[i].Art, Nummer: entries[i].Gebuehr , Bezeichnung: entries[i].Bezeichnung, GebuehrenSatz: entries[i].GebuehrenSatz, Streitwert: entries[i].Streitwert, Gebuehr: entries[i].BetragPKH }

                    var tableRef = document.getElementById('rvgtable').getElementsByTagName('tbody')[0];
                    var newRow = tableRef.insertRow(tableRef.rows.length);

                    var cell = new Array();
                    for (var x = 0; x < 7; x++) {
                        cell[x] = newRow.insertCell(x);
                        cell[x].setAttribute("class", "text-left");
                    }

                    var text = new Array();
                    text[0] = document.createTextNode(this.RVGList[len + 1].Art);
                    text[1] = document.createTextNode(this.RVGList[len + 1].Nummer);
                    text[2] = document.createTextNode(this.RVGList[len + 1].Bezeichnung);
                    text[3] = document.createTextNode(this.RVGList[len + 1].GebuehrenSatz);
                    text[4] = document.createTextNode(this.RVGList[len + 1].Streitwert);
                    text[5] = document.createTextNode(this.RVGList[len + 1].Gebuehr);
                    if (entries[i].Art !== "=") {
                        text[6] = document.createTextNode("19,00");
                    } else {
                        text[6] = document.createTextNode("");
                    }


                    for (var x = 0; x < 7; x++) {
                        cell[x].appendChild(text[x]);
                        
                    }



                    $("#noentry").remove();


                }


            }
        }
    }

    async setLastCase() {
        let data = (await RNSAPI.receiveUserData()).lastVisitedCaseId;
        $("#pnr").val(data);
        //this.loadRVGEntries();
    }

    constructor() {

        this.setLastCase();

        $(document).ready(function () {

            //$(function () {
            //    $('[data-toggle="tooltip"]').tooltip()
            //});

            $.ajaxSetup({
                xhrFields: {
                    withCredentials: true
                },
                crossDomain: true
            });

            var tableRef = document.getElementById('rvgtable').getElementsByTagName('tbody')[0];
            var newRow = tableRef.insertRow(tableRef.rows.length);

            

            var cell = new Array();
            cell[0] = newRow.insertCell(0);
            cell[0].setAttribute("class", "text-center text-muted");
            cell[0].setAttribute("id", "noentry");

            var text = new Array();
            text[0] = document.createTextNode("Keine Einträge vorhanden.");

            cell[0].appendChild(text[0]);
            cell[0].setAttribute("colspan", "8");

            $("#rvgstreitwert").keyup(function () {
                var streitwert = $("#rvgstreitwert").val() as string;
                if (isValidRVG()) {
                    localStorage.setItem("rvgStreitwert", streitwert);
                    calculateGebuehr();
                    updateDisplay();
                }

            })

            $("#rvgnummer").keyup(async function () {
                if (($(this).val() as string).length >= 2) {

                    var pnr = $("#rvgnummer").val();
                    pnr = pnr + " BY NUMBER";


                    let searchObject = {
                        "Query": pnr,
                        "Version": "2013"
                    }

                    localStorage.setItem("rvgStreitwert", $("#rvgstreitwert").val() as string);


                    let response = await RNSAPI.rvgSearch(searchObject);
                    var rvgData = response.Payload.RVGGeb[0];

                    if (typeof rvgData !== 'undefined') {
                        localStorage.setItem("rvgNummer", rvgData.ParagraphNummer.trim());
                        localStorage.setItem("rvgBezeichnung", rvgData.ParagraphBezeichnung.trim());
                        localStorage.setItem("rvgVerfahren", rvgData.Verfahren.trim());
                        localStorage.setItem("rvgGebuehrenSatz", rvgData.GebuehrenSatz.trim());
                        localStorage.setItem("rvgStreitwert", ($("#rvgstreitwert").val() as string).trim());
                        calculateGebuehr();

                    }
                    else {
                        localStorage.clear();
                        updateDisplay();
                    }
                    updateDisplay();
                }
            })
        });

        async function calculateGebuehr() {
            var streitwert = localStorage.getItem("rvgStreitwert");
            var nummer = localStorage.getItem("rvgNummer"); //paragraph
            var version = "2013";

            let calculateObject = {
                "Streitwert": streitwert,
                "Paragraph": nummer,
                "Version": version
            }

            if (isValidRVG()) {
                let response = await RNSAPI.rvgCalculate(calculateObject);

                var rvgData = response.Payload;

                localStorage.setItem("rvgBetrag", rvgData.Gebuehr.trim());

                updateDisplay();
            }
        }

        function updateDisplay() {
            $("#rvgverfahren").val(localStorage.getItem("rvgVerfahren"));
            if (localStorage.getItem("rvgStreitwert") === "" || localStorage.getItem("rvgStreitwert") === null) {
                $("#rvgbezeichnung").val(localStorage.getItem("rvgBezeichnung"));
            } else {
                $("#rvgbezeichnung").val(localStorage.getItem("rvgBezeichnung") + " aus " + localStorage.getItem("rvgStreitwert") + " EUR");
            }
            $("#rvggebuehrensatz").val(localStorage.getItem("rvgGebuehrenSatz"));
            $("#rvgbetrag").val(localStorage.getItem("rvgBetrag"));
        }


        function isValidRVG() {
            var isValid = false;

            if (localStorage.getItem("rvgNummer") !== null) {
                isValid = true;
            }

            return isValid;
        }

   

    }
}


let html = fs.readFileSync(__dirname + '/calculator.html', 'utf8');

ko.components.register("calculator-view", {
    viewModel: CalculatorViewModel,
    template: html
});
